import { attr, html } from '@tempots/dom'

export function NotFoundPage() {
  return html.div(
    attr.class('flex items-center justify-center h-full'),
    html.h1('404 - Page Not Found')
  )
}
